export default {
  methods: {
    /**
     * 文字列切りをする
     *
     * @param {*} value 対象文字列
     * @param {*} length 文字列の先頭開始位置(デフォルトゼロ)
     * @param {*} omission 文字列切りした後の文字(デフォルト'...')
     */
    filter: function(value, length, omission) {
      let len = length ? parseInt(length, 10) : 20
      let ommision = omission ? omission.toString() : '...'

      if (value.length <= len) {
        return value
      } else {
        return value.substring(0, len) + ommision
      }
    }
  }
}
